import * as i0 from '@angular/core';
import { ElementRef, inject, Component, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { Breakpoint, greater, GridStructuralSelectorsService } from '@knorr-bremse-portals/ngx-components';

const breakpointMediaQuery = greater(Breakpoint.MediumSmall);
class MainGridComponent {
    constructor() {
        this.layoutType = 'grid';
        this.gridVariant = 'main';
        this.hostElement = inject(ElementRef);
        this.gridStructuralSelectors = inject(GridStructuralSelectorsService);
    }
    ngAfterViewInit() {
        this.gridStructuralSelectors.attach(this.hostElement.nativeElement, breakpointMediaQuery);
    }
    update() {
        this.gridStructuralSelectors.updateColumnsAndRows(this.hostElement.nativeElement);
    }
    ngOnDestroy() {
        this.gridStructuralSelectors.detach(this.hostElement.nativeElement);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: MainGridComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.7", type: MainGridComponent, isStandalone: true, selector: "kb-main-grid", host: { properties: { "attr.kb-layout": "this.layoutType", "attr.kb-grid-variant": "this.gridVariant" } }, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{margin-bottom:var(--kb-gap--main-column);margin-left:auto;margin-right:auto;max-width:1910px}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: MainGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'kb-main-grid', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [], template: "<ng-content></ng-content>\n", styles: [":host{margin-bottom:var(--kb-gap--main-column);margin-left:auto;margin-right:auto;max-width:1910px}\n"] }]
        }], propDecorators: { layoutType: [{
                type: HostBinding,
                args: ['attr.kb-layout']
            }], gridVariant: [{
                type: HostBinding,
                args: ['attr.kb-grid-variant']
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { MainGridComponent };
